import { Navigate } from "react-router-dom";
import { Layout } from "../components/Layout";
import { CoachTeamsTab } from "../components/CoachTeamsTab";
import { useAuth } from "../contexts/AuthContext";

export default function CoachTeams() {
	const { user } = useAuth();
	const isAdmin = user?.is_admin || user?.role === "admin";
	const isCoach = user?.role === "coach" || isAdmin;

	if (!isCoach) {
		return <Navigate to="/dashboard" replace />;
	}

	return (
		<Layout>
			<CoachTeamsTab />
		</Layout>
	);
}
